import React from 'react';
import useTranslation from '../hooks/useTranslation';

interface PopupBlockedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PopupBlockedModal: React.FC<PopupBlockedModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  // ESC 키로 모달 닫기
  React.useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full mx-4 p-6 text-center">
        {/* 경고 아이콘 */}
        <div className="mb-4">
          <svg 
            className="w-16 h-16 mx-auto text-red-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>

        {/* 제목 */}
        <h2 className="text-xl font-bold text-gray-900 mb-3">
          {t('checkout.popupBlocked.title')}
        </h2>

        {/* 설명 메시지 */}
        <p className="text-gray-600 text-sm mb-4">
          {t('checkout.popupBlocked.message')}
        </p>

        {/* 설정 방법 안내 */}
        <div className="bg-gray-50 rounded-lg p-4 mb-4 text-left">
          <p className="text-gray-700 text-sm mb-2">
            📱 {t('checkout.popupBlocked.instruction.ios')}
          </p>
          <p className="text-gray-700 text-sm">
            💻 {t('checkout.popupBlocked.instruction.other')}
          </p>
        </div>

        {/* 새로고침 버튼 */}
        <button
          onClick={handleRefresh}
          className="w-full py-3 px-4 bg-red-500 hover:bg-red-600 text-white rounded-lg font-semibold transition-colors shadow-lg"
        >
          {t('checkout.popupBlocked.refresh')}
        </button>
      </div>
    </div>
  );
};

export default PopupBlockedModal;

